










































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Utils } from "@/services/utils";
import Number from "@/shared/filters/Number";
import Pagination from "@/views/components/Pagination.vue";

import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import InputString from "@/views/components/input/InputString.vue";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import { CommonService } from "@/services/Common.service";
import { WebRequestResultService } from "@/services/WebRequestResult.service";

interface FormItem {
  groupCd: string;
  shatenCd: string;
  uketsukeCd: string;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputString,
    Pagination
  },
  mixins: [FilterSelectBox]
})

export default class TaxWeightRequestResult extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  util: Utils = new Utils();
  webRequestResultService: WebRequestResultService = new WebRequestResultService();

  loading = false;
  itemSizes: any[] = [
    { label: "5件", value: 5 },
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  itemSizeSelected: number = 5;

  form: FormItem = {
    groupCd: "",
    shatenCd: "",
    uketsukeCd: ""
  };
  // disableBtnSearch: boolean = true;
  showDetailDialog: boolean = false;

  taxWeightRequestResultList: any[] =  [];
  showTaxWeightRequestResultList: any[] =  [];

  selectingTaxWeightRequestResult: any = {};

  private mounted() {
    this.form = {
      groupCd: "",
      shatenCd: "",
      uketsukeCd: ""
    };

    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
      });
    });
  }

  async selectGroup1() {
    this.form.uketsukeCd = "";
    this.selectGroup();
  }

  /**
   * 検索ボタンの活性化
   * グループ、社店が選択され、受付コードの入力があれば、ボタンが活性化する
   */
  get checkDisabled() {
    let disabled = false;
    let btn = "disableBtnSearch";
    if ( this.form.uketsukeCd === "" ) {
      disabled = true;
    }
    // this.$set(this, "disableBtnSearch", disabled);
    return disabled;
  }

  clearFormData() {
    this.form.uketsukeCd = "";
    // this.checkDisabled();
  }

  public async onSearchData() {
    this.$set(this, "loading", true);
    this.taxWeightRequestResultList = [];
    const response = await this.webRequestResultService.getTaxWeightRequestResultByUketsukeCd(
      this.form
    );
    this.$set(this, "loading", false);
    if (response) {
      this.taxWeightRequestResultList = response;
    }
    // this.checkDisabled();
  }

  isSuccess(status: string) {
    if (status === '') {
      return true;
    }
    return false;
  }

  openDetailDialog(row: any) {
    this.showDetailDialog = true;
    this.selectingTaxWeightRequestResult = row;
  }

}
